import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import CompletenessScore from "../../list-venues/CompletenessScore";
import InternetInfoCard from "./InternetInfoCard";
import type { VenueData } from "../../types/venues.types";

interface VenueInternetSectionProps {
  venueData: VenueData;
  completenessScore?: number;
  InfoCard: React.ComponentType<{
    title: string;
    icon: React.ReactNode;
    sx?: object;
    children: React.ReactNode;
  }>;
  InfoRow: React.ComponentType<{
    label: string;
    value: string;
  }>;
}

const VenueInternetSection: React.FC<VenueInternetSectionProps> = ({
  venueData,
  InfoCard,
  InfoRow,
}) => {
  return (
    <Grid container direction="column" spacing={2}>
      {/* TOP CARD — COMPLETENESS SCORE */}
      <Grid>
        <Paper
          sx={{
            boxShadow: 0,
            borderRadius: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
          }}
        >
          <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
            Venue Completeness score
          </Typography>
          <CompletenessScore score={venueData.completeness_score} />
        </Paper>
      </Grid>

      {/* BOTTOM CARD — INTERNET INFO */}
      <Grid>
        <InternetInfoCard
          venueData={venueData}
          InfoCard={InfoCard}
          InfoRow={InfoRow}
        />
      </Grid>
    </Grid>
  );
};

export default VenueInternetSection;
